export const filterUserProfilesByLoginPage = ({
  loginPageOriginator,
  profiles,
}) =>
  (
    profiles.find(profile => profile.originator_name === loginPageOriginator) ||
    profiles[0]
  )?.originator_name || '';
